import { messages } from "@/shared/i18n";

/**
 * Home feature error code mappings
 *
 * Maps backend error identifiers to localized messages.
 *
 * Two types of errors are handled:
 *
 * 1. RFC 7807 Problem Details `title` field (from ChangePasswordCommandHandler):
 *    - "Password.InvalidCurrentPassword"
 *    - "Password.ChangeFailed"
 *
 * 2. FluentValidation `errors[].errorMessage` strings (from ChangePasswordRequestValidator):
 *    - "New password must differ from the current password."
 *    - "Passwords must match."
 */
export const HOME_ERROR_CODES: Record<string, string> = {
  // RFC 7807 title mappings
  "Password.InvalidCurrentPassword": messages.home.changePassword.errors.invalidCurrentPassword,
  "Password.ChangeFailed": messages.home.changePassword.errors.changeFailed,

  // FluentValidation errorMessage mappings
  "New password must differ from the current password.":
    messages.home.changePassword.errors.sameAsCurrentPassword,
  "Passwords must match.": messages.validation.passwordMatch,
};
